const awsKey = 'K5x6nSu1xz5FwtFiMJHS15FJtENMZUDW8hFrz7gM';
export default awsKey;